/* eslint-disable max-len */
import React from 'react';

const iconFeedback = () => (
  <svg
    width="16px"
    height="12px"
    viewBox="0 0 16 12"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-60.000000, -709.000000)">
        <g transform="translate(59.000000, 706.000000)">
          <path d="M15,3 L3,3 C2.175,3 1.5075,3.675 1.5075,4.5 L1.5,13.5 C1.5,14.325 2.175,15 3,15 L15,15 C15.825,15 16.5,14.325 16.5,13.5 L16.5,4.5 C16.5,3.675 15.825,3 15,3 L15,3 Z M15,6 L9,9.75 L3,6 L3,4.5 L9,8.25 L15,4.5 L15,6 L15,6 Z" />
        </g>
      </g>
    </g>
  </svg>
);
export default iconFeedback;
